// extracted by mini-css-extract-plugin
export default {"main":"DSIExportUser_main__KO8NG","table":"DSIExportUser_table__4f3lQ"};